import { useLocation } from 'react-router-dom';
import { useMemo } from 'react';

const keywordToAction = {
  'show-and-hide': 'show_hide_field',
  'update-calculate': 'calculate_field',
  'enable-require': 'require_field',
  'skip': 'go_to_page',
  'thankyou': 'thank_you_page',
  'email-recipient': 'change_email_recipient',
};


export const useActionTypeFromUrl = () => {
  const location = useLocation();

  const actionType = useMemo(() => {
    const currentUrl = location.pathname + location.search;
    for (const keyword in keywordToAction) {
      if (currentUrl.includes(keyword)) {
        return keywordToAction[keyword];
      }
    }
    return undefined;
  }, [location]);

  return actionType;
};
